import { HISTORY } from 'constants/api'
import useAxios from 'axios-hooks'
import { useSession } from 'contexts/session-context'
import { useEffect, useState } from 'react'
import CONFIGS from 'build/Config'
import LoadingScreen from 'components/loading-screen'
import dayjs from 'dayjs'
import calendar from 'dayjs/plugin/calendar'
import utc from 'dayjs/plugin/utc' // Import utc plugin
import timezone from 'dayjs/plugin/timezone' // Import timezone plugin
import {
  CrownState,
  CrownStateText,
  DivStateAccount,
  LiStateAccount,
  PStateAccount,
  TextStateAccount,
  TextStateAccountDate
} from 'theme/profile'
import { TextNotFoundHistory } from 'views/profile/text.style'
import textServices from 'services/text-services'
import useMainClass from 'hooks/use-main-cass'
import PopUpCoupon from './components/PopUp'
import Prize from './components/Prize'
import Details from './components/Details'
import { timeResult } from './utils/functions'

function History() {
  useMainClass('profile__history')

  dayjs.extend(calendar)
  dayjs.extend(utc) // Extend Day.js with utc plugin
  dayjs.extend(timezone) // Extend Day.js with timezone plugin

  const [{ data: session }] = useSession()
  const [{ data, loading, error }, refetch] = useAxios({
    url: HISTORY,
    headers: {
      Authorization: `Bearer ${((session as any)?._tokenResponse as any)?.idToken}`,
      'Ph-Api-Id': PH_API_ID ?? 1
    }
  })

  useEffect(() => {
    refetch()
  }, [])

  const [showPopUpCoupon, setShowPopUpCoupon] = useState<any>(null)
  const [productExchange, setProductExchange] = useState<any>(null)
  const [showOrderNumber, setShowOrderNumber] = useState<any>(null)

  const [showDetails, setShowDetails] = useState<any>(null)

  const closePopup = () => {
    if (showPopUpCoupon) {
      setProductExchange(null)
    }
    setShowPopUpCoupon(!showPopUpCoupon)
    refetch()
  }

  const productExchangeCoupon = (item: any) => {
    setProductExchange(item)
    setShowPopUpCoupon(!showPopUpCoupon)
  }

  if (error) {
    return (
      <div className="flex-1 m-7 flex justify-center items-center">
        <h1 className="text-2xl font-bold">
          {textServices.findByText('profile/view/history/error', {
            es: 'Ha ocurrido un error',
            en: 'An error ocurred'
          })}
        </h1>
      </div>
    )
  }

  if (productExchange) {
    return (
      <PopUpCoupon
        closePopup={closePopup}
        setProductExchange={setProductExchange}
        item={productExchange}
        timeResult={timeResult}
      />
    )
  }

  if (showDetails) {
    return (
      <Details
        setShowDetails={setShowDetails}
        showDetails={showDetails}
        productExchangeCoupon={productExchangeCoupon}
        setShowOrderNumber={setShowOrderNumber}
        showOrderNumber={showOrderNumber}
      />
    )
  }

  return loading ? (
    <LoadingScreen />
  ) : (
    <div>
      {data.length ? (
        <ul>
          {data?.map((item: any) => {
            if (CONFIGS?.tracking) {
              return (
                <Prize
                  item={item}
                  setShowDetails={setShowDetails}
                  key={item?.exchangeAt}
                  productExchangeCoupon={productExchangeCoupon}
                  timeResult={timeResult}
                />
              )
            }

            return (
              <LiStateAccount
                key={item.exchangeAt}
                className="relative border-b-2 state-container profile__history__product"
              >
                <DivStateAccount className="h-16 flex items-center px-10 state-bg profile__history__product__bg__1"></DivStateAccount>
                <div className="h-28 state-bg-two profile__history__product__bg__2"></div>
                <div className="absolute top-0 grid state-grid" style={{ gridTemplateColumns: '176px 1fr' }}>
                  <div
                    className="flex justify-center items-center h-full state-image-container"
                    style={{ height: 176 }}
                  >
                    {!item?.imageUrl && (
                      <CrownState
                        className="w-28 h-28 flex justify-center items-center state-crown"
                        style={{ backgroundSize: 'contain' }}
                      >
                        <CrownStateText className="text-4xl font-bold">{item.pointsEarned}</CrownStateText>
                      </CrownState>
                    )}
                    {item?.imageUrl && (
                      <img
                        src={item?.imageUrl}
                        alt={`Foto del premio ${item.title}`}
                        style={{ height: 'auto', width: 'auto', maxHeight: 124, maxWidth: 124 }}
                        className="state-img"
                      />
                    )}
                  </div>
                  <div
                    className="grid state-text-container profile__history__product__content"
                    style={{ gridTemplateRows: '64px 112px' }}
                  >
                    <div className="flex items-center">
                      <PStateAccount
                        className={`font-bold state-title ${
                          item.title.length > 30 ? 'text-xl' : 'text-2xl'
                        } profile__history__product__content__title`}
                      >
                        {item.title}
                      </PStateAccount>
                    </div>
                    <div className="py-2 text-left">
                      {item.costInPoints && item.costInPoints !== '0' && (
                        <TextStateAccount className="din font-bold text-sm state-text state-cost-points profile__history__product__content__points">
                          {item?.costInPoints > 0 && '-'}
                          {item.costInPoints} {POINTS_NAME}
                        </TextStateAccount>
                      )}
                      {item.dynamicCostInPoints && item.dynamicCostInPoints !== '0' && (
                        <TextStateAccount className="din font-bold text-sm state-text state-dynamic-points profile__history__product__content__used">
                          {item.dynamicCostInPoints} {POINTS_NAME}{' '}
                          {textServices.findByText('profile/view/history/used', { es: 'USADAS', en: 'USED' })}
                        </TextStateAccount>
                      )}
                      {item.pointsEarned && item.pointsEarned !== '0' && (
                        <TextStateAccount className="din font-bold text-sm state-text state-earned-points profile__history__product__content__win">
                          {item.pointsEarned} {POINTS_NAME}{' '}
                          {textServices.findByText('profile/view/history/acquireds', {
                            es: 'ADQUIRIDAS',
                            en: 'ACQUIRED'
                          })}
                        </TextStateAccount>
                      )}
                      {item.dynamicTitle && item.dynamicTitle !== '0' && (
                        <TextStateAccount className="text-sm state-text state-dynamic-title">
                          {item?.dynamicType}: {item.dynamicTitle}
                        </TextStateAccount>
                      )}
                      <TextStateAccountDate className="text-sm state-text state-text-date profile__history__product__content__date">
                        #{item?.id} -{' '}
                        {textServices.findByText('profile/view/history/acquired', {
                          es: 'Adquirido el',
                          en: 'Acquired on'
                        })}{' '}
                        {dayjs(item.exchangeAt).tz('America/Mexico_City').format('DD/MM/YY')}
                      </TextStateAccountDate>
                      {(item?.orderStatus === 6 || item?.temporalCouponExpiresAt) && (
                        <button
                          onClick={() => {
                            if (item?.orderStatus === 6 || timeResult(item?.temporalCouponExpiresAt)) {
                              productExchangeCoupon(item)
                            }
                          }}
                          className={`profile__history__button__base ${
                            item?.orderStatus === 6 ? 'profile__history__button__active' : ''
                          } ${timeResult(item?.temporalCouponExpiresAt) ? 'profile__history__button__progress' : ''} ${
                            item?.orderStatus === 7 && !timeResult(item?.temporalCouponExpiresAt)
                              ? 'profile__history__button__finish'
                              : ''
                          }`}
                          disabled={item?.orderStatus === 7 && !timeResult(item?.temporalCouponExpiresAt)}
                        >
                          {item?.orderStatus === 6 &&
                            textServices.findByText('profile/coupon/activate', { es: 'ACTIVAR', en: 'ACTIVATE' })}
                          {timeResult(item?.temporalCouponExpiresAt) &&
                            textServices.findByText('profile/coupon/active', {
                              es: 'Ver cupón activo',
                              en: 'View coupon active'
                            })}
                          {item?.orderStatus === 7 &&
                            !timeResult(item?.temporalCouponExpiresAt) &&
                            textServices.findByText('profile/coupon/used', { es: 'cupón usado', en: 'coupon used' })}
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </LiStateAccount>
            )
          })}
        </ul>
      ) : (
        <TextNotFoundHistory className="text-2xl font-bold text-center mt-20">
          {textServices.findByText('profile/stateNotFound', {
            es: (
              <>
                No has canjeado ningún premio aún<br></br>
                <br></br>
                ¡Venga, tú puedes!
              </>
            ),
            en: (
              <>
                You haven&apos;t redeemed any prizes yet<br></br>
                <br></br>
                Come on, you can do it!
              </>
            )
          })}
        </TextNotFoundHistory>
      )}
    </div>
  )
}

export default History